import {css} from 'lit';
export const styles = css`:host {
  --avatar-size: 120px;
  --avatar-border-size: 6px;
  --status-border-size: 2px;
  --slot-font-size: 24px;
  --padding: 14px;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

  @media (min-width: 786px) {:host {
    --avatar-size: 60px;
    --avatar-border-size: 4px;
    --status-border-size: 2px;
    --slot-font-size: var(--font-size-base);

    flex-direction: row;
    padding: var(--padding);
    background-color: var(--contrast-light);
    border-radius: var(--border-radius)
}
  }

ef-avatar {
  border: var(--avatar-border-size) solid var(--contrast-light);
}

@media (min-width: 786px) {

ef-avatar {
    margin-right: 16px
}
  }

.wrapper {
  display: flex;
}

@media (min-width: 768px) {

.wrapper {
    flex-direction: column;
    align-items: flex-start
}
  }

slot::slotted(*) {
  font-weight: 700;
  font-size: var(--slot-font-size);
  margin-top: 16px;
}

@media (min-width: 786px) {

slot::slotted(*) {
    margin-top: 0;
    line-height: 1;
    margin-bottom: 8px
}
  }

xs-origin {
  display: none;
}

@media (min-width: 768px) {

xs-origin {
    display: inline-flex;
    font-size: 14px;
    color: var(--dark-text-secondary)
}
  }

ef-online-status {
  --border: transparent;
  --border-secondary: #3edb3e;
  --background: transparent;
  --background-secondary: transparent;
  --size: 120px;
  --border-size: var(--status-border-size);

  position: absolute;
  top: 0;
}

@media (min-width: 786px) {

ef-online-status {
    --size: 60px;

    top: var(--padding)
}
  }
`;
export default styles;
